import { SubPageLayout } from "@/components/SubPageLayout";
import { SITE_IMAGES } from "@/lib/site-data";

export default function PonyvaMobilGarazs() {
  return (
    <SubPageLayout
      eyebrow="Mobil garázs"
      title="Harmonika rendszerű ponyvagarázs."
      intro="Áthelyezhető, harmonika rendszerű ponyvagarázs autóknak, géppark és anyag tárolásához. Gyors telepítés, alacsony fenntartás."
      heroImage="/assets/gallery/egyedi-01.jpg"
      bullets={[
        { title: "Harmonika szerkezet", text: "Összehajtható, könnyen mozgatható, minimális rögzítéssel könnyen telepíthető." },
        { title: "Erős anyag", text: "PVC kamion ponyva, vízálló, hosszú élettartam." },
        { title: "Áthelyezhető", text: "Könnyen szétszedhető és újra felépíthető más helyszínen." },
      ]}
      gallery={SITE_IMAGES.garageGallery}
    />
  );
}
